import { Popup } from '@/components/popup/popup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockResetIcon from '@mui/icons-material/LockReset';
import { Typography, Box, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ReloginConfirmationProps {
  open: boolean;
  message: string;
  onConfirm: () => void;
}

export const ReloginConfirmation = ({ open, message, onConfirm }: ReloginConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      open={open}
      onClose={() => {}} // Prevent closing
      closeButton={false}
      dialogTitle={t('account:reloginRequired')}
      dialogContent={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <CheckCircleIcon sx={{ color: 'success.light' }} />
            <Typography sx={{ fontWeight: 600 }}>{message}</Typography>
          </Box>
          <Alert icon={<LockResetIcon fontSize="inherit" />} severity="info" sx={{ alignItems: 'center' }}>
            {t('account:pleaseReloginToContinue')}
          </Alert>
        </Box>
      }
      dialogActions={
        <Button variant="contained" onClick={onConfirm} sx={{ minWidth: '170px' }}>
          {t('account:login')}
        </Button>
      }
    />
  );
};
